<template>
  <div class="nav-main">
    <span class="title">栏目导航</span>
    <ul class="fl">
      <li :class="[{'active': now === 1} ,'fl-content']" @click="flChoose(1)">
        <img src="../../assets/imgs/spec/arrow_navigation_red.png" alt="" v-if="now===1">
        {{flDetails[0]}}
      </li>
      <li :class="[{'active': now === 2} ,'fl-content']" @click="flChoose(2)" v-if="flDetails.length > 1">
        <img src="../../assets/imgs/spec/arrow_navigation_red.png" alt="" v-if="now===2">
        {{flDetails[1]}}
      </li>
      <li :class="[{'active': now === 3} ,'fl-content']" @click="flChoose(3)" v-if="flDetails.length > 2">
        <img src="../../assets/imgs/spec/arrow_navigation_red.png" alt="" v-if="now===3">
        {{flDetails[2]}}
      </li>
      <li :class="[{'active': now === 4} ,'fl-content']" @click="flChoose(4)" v-if="flDetails.length > 3">
        <img src="../../assets/imgs/spec/arrow_navigation_red.png" alt="" v-if="now===4">
        {{flDetails[3]}}
      </li>
      <li :class="[{'active': now === 5} ,'fl-content']" @click="flChoose(5)" v-if="flDetails.length > 4">
        <img src="../../assets/imgs/spec/arrow_navigation_red.png" alt="" v-if="now===5">
        {{flDetails[4]}}
      </li>
      <li :class="[{'active': now === 6} ,'fl-content']" @click="flChoose(6)" v-if="flDetails.length > 5">
        <img src="../../assets/imgs/spec/arrow_navigation_red.png" alt="" v-if="now===6">
        {{flDetails[5]}}
      </li>
      <li :class="[{'active': now === 7} ,'fl-content']" @click="flChoose(7)" v-if="flDetails.length > 6">
        <img src="../../assets/imgs/spec/arrow_navigation_red.png" alt="" v-if="now===7">
        {{flDetails[6]}}
      </li>
      <li :class="[{'active': now === 8} ,'fl-content']" @click="flChoose(8)" v-if="flDetails.length > 7">
        <img src="../../assets/imgs/spec/arrow_navigation_red.png" alt="" v-if="now===8">
        {{flDetails[7]}}
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    name: "ColumnNav",
    data() {
      return {
        now: this.nowColumn
      }
    },
    props: {
      flDetails: Array,
      nowColumn: Number
    },
    methods: {
      flChoose(num) {
        this.now = num
        this.$emit('b-content',num)
      }
    },
    computed: {
      navStore() {
        return this.$store.state.childNum
      }
    },
    watch: {
      navStore: function (old) {
        this.now = old
        this.$emit('b-content',old)
      }
    }
  }
</script>

<style scoped lang="scss">
  .nav-main {
    width: 180px;
    height: fit-content;
    min-height: 304px;
    display: flex;
    flex-direction: column;
    background-color: #f9f9f9;
    border: solid 1px #d9d9d9;
    border-top: solid 2px #d43e42;
    .title {
      width: 180px;
      height: 40px;
      text-indent: 20px;
      font-family: 'SourceHanSerifCN-Bold';
      font-size: 18px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 41px;
      letter-spacing: 0;
      color: #d43e42;
      border-bottom: solid 1px #d9d9d9;
    }
    .fl {
      width: 138px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin: 0 auto;
      .fl-content {
        cursor: pointer;
        width: 138px;
        font-family: 'SourceHanSansCN-Regular';
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        min-height: 36px;
        line-height: 36px;
        letter-spacing: 0;
        color: #464646;
        display: flex;
        align-items: center;
        border-bottom: solid 1px #d9d9d9;
      }
      .fl-content:hover {
        color: #d43e42;
      }
      .active {
        color: #d43e42;
      }
      img {
        width: 6px;
        height: 7px;
        margin-right: 5px;
      }
    }
  }
</style>
